import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class EspotService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/espot');

  getEspotDataByTitle(storeId: string, title: string) {
    const searchParams = new URLSearchParams({ title, storeId });

    return this.api.getJSON(`${EspotService.baseUrl}/title?${searchParams.toString()}`).pipe(
      catchError((_err) => of({}))
    );
  }

  getEspotDataByLocation(storeId: string, location: string) {
    const searchParams = new URLSearchParams({ location, storeId });

    return this.api.getJSON(`${EspotService.baseUrl}/location?${searchParams.toString()}`).pipe(
      catchError((_err) => of({}))
    );
  }

  getEspotDataByLocations(storeId: string, locations: string[]) {
    const searchParams = new URLSearchParams({ storeId });
    locations.forEach((location) => searchParams.append('location', location));

    return this.api.getJSON(`${EspotService.baseUrl}/multipleLocation?${searchParams.toString()}`).pipe(
      // TODO: spots are returned in the wrong order => remove the following map() when back will be corrected
      map((spots) => locations.map((location) => spots.find((spot) => spot.location === location))),
      catchError((_err) => of([]))
    );
  }

  getEspotDataById(id: string) {
    return this.api.getJSON(`${EspotService.baseUrl}/${id}`).pipe(
      catchError((_err) => of({}))
    );
  }

  getEspotDataByStoreId(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${EspotService.baseUrl}/byStoreId?${searchParams.toString()}`).pipe(
      catchError((_err) => of({}))
    );
  }

  getEspotByTypeAndStoreId(type: string, storeId: string) {
    const searchParams = new URLSearchParams({ type, storeId });

    return this.api.getJSON(`${EspotService.baseUrl}/espotEmptyItem?${searchParams.toString()}`);
  }
}
